import { initializeApp } from "firebase/app";
import { getAuth, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";

// Debug: Log environment variables
console.log('Firebase Config:', {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
});

// Development fallbacks to prevent crashes when env vars are missing
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "demo-api-key",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "demo-project.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "demo-project.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "123456789012",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:123456789012:web:demo"
};

// Initialize Firebase with error handling
let app, auth;
try {
  console.log('🔥 Initializing Firebase app...');
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase app initialized:', app.name);
  
  console.log('🔥 Getting Firebase auth...');
  auth = getAuth(app);
  console.log('✅ Firebase auth initialized:', !!auth);
  // Ensure persistence is set to default (browser) so SPA route changes don't clear session
} catch (error) {
  console.error('🚨 Firebase initialization failed:', error);
  // Set auth to null so AuthContext can handle it gracefully
  auth = null;
}

// Development warning
if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_API_KEY === undefined) {
  console.warn('⚠️ Firebase environment variables not configured for development');
  console.warn('Create frontend/.env.local with Firebase configuration to enable authentication');
}

export { auth, EmailAuthProvider, reauthenticateWithCredential };

